<template>
    <div>
        <section>
            <div class="searchBox">
                <div>
                    <el-form :inline="true" class="demo-form-inline">
                        <el-form-item label="工艺选择">
                            <el-select placeholder="工艺选择" clearable size="small"
                                        v-model="technologyType" @change="getMaterialArt">
                                <el-option :label="items.name" :value="items.uuid"
                                            v-for="(items,index) in cailiaoList"
                                            :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="材料选择">
                            <el-select placeholder="材料选择" clearable size="small"
                                        v-model="firstMaterialClassify" @change="handMaterialItems">
                                <el-option :label="items.name" :value="items.uuid"
                                            v-for="(items,index) in serverList" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="margin-top: -7px;">
                    <el-input
                        class="searchInput"
                        size="small"
                        @change="changeManagerInfo"
                        v-model="managerName"
                        placeholder="输入关键字"
                        suffix-icon="el-icon-search">
                    </el-input>
                </div>
            </div>
               <div v-if="printList.length==0" style="text-align:center;margin-bottom:20px" >
                    <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
                </div>
            <el-row :gutter="30" style="display: flex;flex-wrap: wrap;width:73%" v-if="printList.length!=0">
                <el-col :span="8" v-for="(items, index) in printList" :key="index">
                    <el-card class="box-card" shadow="hover">
                        <h4 class="mpTitle">{{ items.materialName }}</h4>
                        <p class="mpPrice">¥{{ items.unitPrice }}元/克</p>
                        <div class="mpBox">
                            <el-image
                                style="width: 100px; height: 70px; margin-right: 15px"
                                :src="items.thumbUrl"
                                fit="fill"
                            >
                            </el-image>
                            <div class="mpInfo">
                                <dl class="mpDetail clearfix">
                                    <dt>工作温度：</dt>
                                    <dd :title="`${items.operationTemperature}℃`" style="width: 60px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{ items.operationTemperature }}℃</dd>
                                    <dt>尺寸精度：</dt>
                                    <dd>{{ items.sizePrecision }}mm</dd>
                                    <dt>发货周期：</dt>
                                    <dd>{{ items.sendCycleMin }}-{{ items.sendCycleMax }}天</dd>
                                </dl>
                            </div>
                        </div>
                        <div class="tagsbox">
                            <el-tag size="mini" type="danger">
                                {{ items.technologyName }}
                            </el-tag>
                        </div>
                        <div>
                            <dl class="mpDetail">
                                <dt>表面质感：</dt>
                                <dd style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                                    {{ items.surfaceTexture }}
                                </dd>
                                <dt>材料特点：</dt>
                                <dd :title="items.characteristic"
                                    style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;min-height: 64px;">
                                    {{ items.characteristic }}
                                </dd>
                                <dt>打印设备：</dt>
                                <dd :title="items.printMachine"
                                    style="display: -webkit-box;-webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;overflow: hidden;">
                                    {{ items.printMachine }}
                                </dd>
                                <dt>交易量：</dt>
                                <dd :title="items.totalNum"
                                    style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;min-height: 44px;">
                                    {{ items.totalNum }}
                                </dd>
                            </dl>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <div style="text-align: right">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    @prev-click="handleCurrentChange"
                    @next-click="handleCurrentChange"
                    layout="total,prev, pager, next,jumper"
                    :current-page="current"
                    :page-size="pageSize"
                    :total="total" class="pagination">
                </el-pagination>
            </div>
        </section>
    </div>
</template>

<script>
    import {
        getDictionaryItem, getMaterialList,
        getDictionaryGroup
    } from "../../utils/interface";

    export default {
        //   打印材料
        name: "printMaterial",
        components: {},
        data() {
            return {
                uuid: '',
                enterPriseId: '',
                groupCode: "print_banner",
                technologyCode: 'technology_print',
                parentCode: 'material_print',
                current: 1,
                total: 0,
                pageSize: 6,
                materialId: '',
                serviceId: '',
                printList: [],
                cailiaoList: [],
                serverList: [],
                firstMaterialClassify: '',
                technologyType: '',
                managerName: '',
            };
        },
        created() {
            this.uuid = this.$route.params.uuid;
            this.enterPriseId = this.$route.params.enterPriseId;
            this.getItemList();
            this.getDictionaryGroup();
            this.getMaterialManagerList();
        },
        methods: {
            // 查询条件
            getItemList() {
                let params = {
                    groupCode: this.technologyCode,
                };
                getDictionaryItem(params).then((res) => {
                    this.cailiaoList = res;
                });
            },
            getDictionaryGroup() {
                let params = {
                    parentCode: this.parentCode,
                };
                getDictionaryGroup(params).then((res) => {
                    this.serverList = res;
                });
            },
            changeManagerInfo() {
                this.current = 1;
                this.getMaterialManagerList();
            },
            handMaterialItems(uuid) {
                this.firstMaterialClassify = uuid;
                this.getMaterialManagerList();
            },
            getMaterialArt(uuid) {
                this.technologyType = uuid;
                this.getMaterialManagerList();
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
				window.scrollTo(0,0);
                this.getMaterialManagerList()
            },
            // 材料管理
            getMaterialManagerList() {
                let params = {
                    technologyType: this.technologyType,
                    firstMaterialClassify: this.firstMaterialClassify,
                    current: this.current,
                    pageSize: this.pageSize,
                    enterPriseId: this.enterPriseId,
                    managerName: this.managerName,
                };
                getMaterialList(params).then((res) => {
                    this.printList = res.list;
                    this.total = res.total;
                    this.pageSize = res.size;
                    this.current = res.current;
                });
            },
        },
    };
</script>

<style scoped lang="less">
    .container {
        width: 1200px;
        margin: 0 auto;
    }

    .leftCont {
        margin-top: 30px;

        .leftCard {
            margin-bottom: 30px;
            border: none;

            /deep/ .el-card__header {
                color: #157EFB;
                background-color: #F3F3F3;
                font-size: 18px;
                padding: 12px 20px;
            }

            /deep/ .el-card__body {
                background-color: #fbfbfb;
				padding: 20px 15px 15px 15px;
            }
        }

        .servInfo h3 {
            font-size: 16px;
            font-weight: normal;
            margin-bottom: 15px;
        }

        .servInfo .eval li {
            font-size: 14px;
            margin-bottom: 10px;
            display: flex;
        }

        .servInfo .eval li span {
            margin-right: 30px;
        }

        .servInfo .contact {
            margin-top: 30px;
            margin-bottom: -10px;
            font-size: 12px;
        }

        .servInfo .contact i {
            margin-right: 5px;
        }

        .servInfo .contact p {
            font-size: 14px;
            margin-bottom: 10px;
        }
    }

    .printTitle {
        font-size: 16px;
        font-weight: normal;
        color: #157EFB;
        margin-top: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #e3e3e3;
        padding-bottom: 10px;

        span.tit {
            padding-bottom: 10px;
            border-bottom: 1px solid #157EFB;
        }

        span.more {
            font-size: 16px;
            float: right;
            margin-top: 10px;
        }

        .more i {
            color: #505050 !important;
        }
    }

    .hotSell {
        margin-bottom: -30px;

        li {
            margin-bottom: 30px;
        }

        .topServBoxInfo h3 {
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: normal;
        }

        .topServBoxInfo p {
            font-size: 12px;
            color: #aaa;
        }
    }

    .relateServ {
        margin-bottom: -30px;

        li {
            margin-bottom: 30px;
        }

        .topServBoxInfo h3 {
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: normal;
        }
    }

    .topServBox {
        background-color: #fff;
        height: 200px;
        border-radius: 8px;
        box-shadow: 0 1px 5px #eaeaea;
        margin-top: -100px;
        padding: 30px;
        box-sizing: border-box;

        .topServBoxInfo h3 {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: normal;
        }

        .topServBoxInfo p {
            font-size: 12px;
            color: #585858;
        }

        /deep/ .el-menu.el-menu--horizontal {
            border-color: transparent;
        }

        /deep/ .el-menu--horizontal > .el-menu-item.is-active {
            border: none !important;
            background-color: #F3F8FF;
            border-radius: 5px;
        }

        /deep/ .el-menu--horizontal > .el-menu-item {
            height: 30px;
            line-height: 26px;
        }
    }

    .topServBoxNum {
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;

        p:first-child {
            font-size: 16px;
        }

        p:last-child {
            font-size: 12px;
            color: #585858;
        }
    }

    .menu-sub {
        margin-top: 35px;
        font-size: 16px;
    }

    .box-card {
        margin-bottom: 30px;
        position: relative;

        .image {
            width: 100%;
            height: 200px;
            display: block;
        }
    }

    .searchBox {
        background-color: #FAFCFF;
        height: 50px;
        line-height: 50px;
        margin: 30px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;

        .searchInput /deep/ .el-input__inner {
            border-radius: 30px;
        }

        /deep/ .el-form-item {
            margin-bottom: 0;
        }

        /deep/ .el-form-item__label {
            line-height: inherit;
        }

        /deep/ .el-form-item__content {
            line-height: inherit;
        }
    }

    .mpBox {
        display: flex;
        align-items: center;
    }

    .mpCheck {
        position: absolute;
        right: 20px;
        top: 20px;
    }

    .mpTitle {
        font-size: 16px;
        font-weight: normal;
    }

    .mpComp {
        margin-top: 10px;
        font-size: 13px;
        color: #000000;
    }

    .mpPrice {
        margin: 10px 0;
        font-size: 13px;
        color: #DA251D;

        span {
            color: #000;
            margin-left: 10px;
        }
    }

    .mpDetail {
        margin-top: 10px;

        dt {
            float: left;
            width: 70px;
            color: #000;
            font-size: 13px;
            font-weight: normal;
            line-height: 22px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
        }

        dd {
            font-size: 13px;
            line-height: 22px !important;
            margin-left: 70px;
            margin-bottom: 6px;
            color: #808080;
            font-weight: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
        }
    }

    .mpFooter-v1 {
        text-align: center;
        font-size: 14px;
        background: #F1F5FE;
        border: 1px solid #EBEEF5;
        margin: -10px -21px -21px;
        height: 50px;
        line-height: 50px;
    }

    .mpFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        border-top: 1px solid #E3E3E3;
        margin: 0 0 -15px;
        position: relative;

        span {
            display: inline-block;
            width: 50%;
            text-align: center;
            font-size: 13px;
            height: 50px;
            line-height: 50px;
        }

        span a {
            font-size: 12px;
            color: #808080;
        }

        span a:hover {
            color: rgba(21, 126, 251, 0.80);
        }

        :after {
            position: absolute;
            content: '';
            width: 1px;
            background-color: #e3e3e3;
            height: 34px;
            top: 8px;
            left: 50%;
        }
    }

    .printBox {
        /deep/ .el-input--suffix .el-input__inner {
            padding: 0 15px;
        }
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    a {
        color: #157EFB;
    }

    a:hover {
        color: rgba(21, 126, 251, 0.80);
    }
</style>



// WEBPACK FOOTER //
// src/components/print/printMaterial.vue